import { useState, useContext, useEffect } from "react";
import { useSignIn, useSignOut } from "react-auth-kit";
import { useNavigate } from "react-router-dom";
import { sendApiRequest } from "../../services/Base/base-service";
import {
  Alert,
  Modal,
  ModalBody,
  ModalHeader,
  Spinner,
} from "design-react-kit";

import UserContext from "../../store/user-context";
import PfdSidebar from "../PfdSidebar";
import FlowTypeEnum from "../../helpers/Enums/FlowTypeEnum";

const FilesViewModal = ({
  modalOpen,
  modalCloseHandler,
  notificationId,
  notificationSubject,
  flowType,
  recipientId,
  description,
}) => {
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [files, setFiles] = useState([]);

  const signIn = useSignIn();
  const signOut = useSignOut();
  const navigate = useNavigate();

  const userContext = useContext(UserContext);

  useEffect(() => {
    if (modalOpen) {
      if (flowType !== FlowTypeEnum.Json_v2) {
        getNotificationFiles();
      } else {
        if (recipientId !== null) {
          getStagedFlowNotificationRecipientPaymentFiles();
        } else {
          getStagedFlowNotificationAttachments();
        }
      }
    } else {
      setFiles([]);
      setError(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [modalOpen]);

  const getNotificationFiles = () => {
    setIsLoading(true);
    setError(null);
    setTimeout(() => {
      sendApiRequest(
        `StagedFlowNotificationFiles/GetStagedFlowNotificationFiles?stagedFlowNotificationId=${notificationId}`,
        "GET",
        true,
        null,
        signIn,
        signOut,
        navigate,
        null,
        userContext,
      ).then((response) => {
        if (response !== undefined) {
          if (response.errors !== null) {
            setError(response.errors);
            setIsLoading(false);
          } else {
            setError(null);
            setFiles(response.data);
            setIsLoading(false);
          }
        }
      });
    }, 500);
  };

  const getStagedFlowNotificationAttachments = () => {
    setIsLoading(true);
    setError(null);
    setTimeout(() => {
      sendApiRequest(
        `StagedFlowNotificationFiles/getStagedFlowNotificationAttachments?stagedFlowNotificationId=${notificationId}`,
        "GET",
        true,
        null,
        signIn,
        signOut,
        navigate,
        null,
        userContext,
      ).then((response) => {
        if (response !== undefined) {
          if (response.errors !== null) {
            setError(response.errors);
            setIsLoading(false);
          } else {
            setError(null);
            setFiles(response.data);
            setIsLoading(false);
          }
        }
      });
    }, 500);
  };

  const getStagedFlowNotificationRecipientPaymentFiles = () => {
    setIsLoading(true);
    setError(null);
    setTimeout(() => {
      sendApiRequest(
        `StagedFlowNotificationFiles/GetStagedFlowNotificationRecipientPaymentFiles?recipientId=${recipientId}&description=${encodeURIComponent(
          description,
        )}`,
        "GET",
        true,
        null,
        signIn,
        signOut,
        navigate,
        null,
        userContext,
      ).then((response) => {
        if (response !== undefined) {
          if (response.errors !== null) {
            setError(response.errors);
            setIsLoading(false);
          } else {
            setError(null);
            setFiles(response.data);
            setIsLoading(false);
          }
        }
      });
    }, 500);
  };

  return (
    <Modal
      id="filesModal"
      isOpen={modalOpen}
      toggle={modalCloseHandler}
      align="center"
      scrollable
      labelledBy="filesView"
    >
      <ModalHeader toggle={modalCloseHandler} id="filesView">
        {notificationSubject}
      </ModalHeader>
      <ModalBody>
        <div className="position-relative">
          {isLoading && (
            <p style={{ height: "50px" }}>
              <Spinner double active />
            </p>
          )}
        </div>
        {files !== null && files.length > 0 && (
          <div className="content d-flex justify-content-center">
            <PfdSidebar files={files} />
          </div>
        )}

        {error === null && files.length === 0 && !isLoading && (
          <div colSpan={12}>
            <Alert className="w-50 mx-auto" color="info">
              Nessun risultato trovato!
            </Alert>
          </div>
        )}

        {error !== null && error.length !== undefined && (
          <Alert color="danger" className="mx-auto">
            {error.map((item) => (
              <p key={item}>{item}</p>
            ))}
          </Alert>
        )}
      </ModalBody>
    </Modal>
  );
};

export default FilesViewModal;
